<template>
  <div class="d-flex flex-column align-items-center justify-content-center flex-grow-1">
    <div
      class="spinner-border mb-2 text-primary"
      role="status"
    >
  <span class="visually-hidden">{{ $t("common.loading") }}</span>
    </div>
    <p v-if="msg">{{ msg }}</p>
  <p v-else>{{ $t("common.loading") }}</p>
  </div>
</template>

<script>
  export default {
    name: "LoadingComponent",
    props: {
      msg: String,
    },
  };
</script>
